import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getEnvelopeDocumentDetail,
  getEnvelopeRequestInformationDetail,
  modifyDocumentRequestFormOrders,
  removeEnvelopeDocument,
  removeEnvelopeRequestForm,
  removeEnvelopeSignDocument,
  checkMyFilesEnabled
} from "../../../../services/CommonService";
import Utils from "../../../../utils";
import { toast } from "react-toastify";
import EnvelopeDocument from "./Document";
import EnvelopePreview from "./Preview";
import DocFormTemplate from "./DocFormTemplate";
import { Lang } from "../../../../lang";
import EnvelopeRequestForm from "./RequestForm";
import PdfUploadPopup from "./PdfUploadPopup";
import MakeFillablePopup from "./MakeFillablePopup";
import '../../../../assets/sleeve.css';
import SmartForm from "./SmartForm";

function EnvelopeStep3(props) {
  const navigate = useNavigate();
  const [fromTemplate, setFromTemplate] = useState(1);
  const [isUseFromTemplate, setIsUseFromTemplate] = useState(false);
  const [directMakeFillableOpen, setDirectMakeFillableOpen] = useState(false);

  const [docData, setDocData] = useState({
    id: 0,
    request_id: 0,
    doc_name: "",
    doc_detail: "",
    documents: [],
    date_format: 0,
    sign_documents: [],
  });

  const [requestFormData, setRequestFormData] = useState({
    id: 0,
    request_id: 0,
    form_name: "",
    form_questions: []
  });
  const [smartFormData, setSmartFormData] = useState({
    id: 0,
    request_id: 0,
    form_name: "",
    form_questions: [],
  });

  const [signatureDocumentData, setSignatureDocumentData] = useState(null);
  const btnSignDocumentPopup = useRef(null);


  const btnDocument = useRef(null);
  const docDragItem = useRef();
  const docDragOverItem = useRef();

  const btnRequestForm = useRef(null);
  const formDragItem = useRef();
  const formDragOverItem = useRef();

  const signDragItem = useRef();
  const signDragOverItem = useRef();

  const [makeFillable, setMakeFillable] = useState(false);

  // const [activeRequestType, setActiveRequestType] = useState('document');
  // const [activeTemplate, setActiveTemplate] = useState("information"); 


  const [requestName, setRequestName] = useState("");
  const [requestType, setRequestType] = useState("Document");
  const [requestDesc, setRequestDesc] = useState("");
  const [requests, setRequests] = useState([]);


  const [selectedTab, setSelectedTab] = useState("DocumentRequest");

  // const handleCardClick = (key) => {
  //   setSelectedTab(key);
  //   if (key === 'document') {
  //     document.getElementById('MyTemplatesDetails')?.click();
  //   } else if (key === 'information') {
  //     document.getElementById('sharedWithMe-tab')?.click();
  //   } else if (key === 'signature') {
  //     document.getElementById('DocutikTemplates-tab')?.click();
  //   }
  // };

  const [docDragOverIndex, setDocDragOverIndex] = useState(null);
  const [formDragOverIndex, setFormDragOverIndex] = useState(null);
  const [signDragOverIndex, setSignDragOverIndex] = useState(null);

  const handleDocDragStart = (index) => {
    docDragItem.current = index;
  };

  const handleDocDragEnter = (index) => {
    setDocDragOverIndex(index);
    docDragOverItem.current = index;
  };

  const handleDocDragEnd = () => {
    const formData = { ...props.formObj };
    const copyListItems = [...formData.documents];
    const dragged = copyListItems.splice(docDragItem.current, 1)[0];
    copyListItems.splice(docDragOverItem.current, 0, dragged);
    formData.documents = copyListItems;
    props.setFormObj(formData);
    docDragItem.current = null;
    docDragOverItem.current = null;
    setDocDragOverIndex(null);
  };

  const formDragStart = (e, position) => {
    formDragItem.current = position;
  };

  const formDragEnter = (e, position) => {
    setFormDragOverIndex(position);
    formDragOverItem.current = position;
  };

  const formDrop = (e) => {
    const formData = { ...props.formObj };
    const copyListItems = [...formData.fill_forms];
    const dragItemContent = copyListItems[formDragItem.current];
    copyListItems.splice(formDragItem.current, 1);
    copyListItems.splice(formDragOverItem.current, 0, dragItemContent);
    formDragItem.current = null;
    formDragOverItem.current = null;
    setFormDragOverIndex(null);
    formData.fill_forms = copyListItems;
    props.setFormObj(formData);
  };



  const signDragStart = (e, position) => {
    signDragItem.current = position;
  };

  const signDragEnter = (e, position) => {
    setSignDragOverIndex(position);
    signDragOverItem.current = position;
  };

  const signDrop = (e) => {
    const formData = { ...props.formObj };
    const copyListItems = [...formData.sign_documents];
    const dragItemContent = copyListItems[signDragItem.current];
    copyListItems.splice(signDragItem.current, 1);
    copyListItems.splice(signDragOverItem.current, 0, dragItemContent);
    signDragItem.current = null;
    signDragOverItem.current = null;
    setSignDragOverIndex(null);
    formData.sign_documents = copyListItems;
    props.setFormObj(formData);
  };

  function onBack(e) {
    e.preventDefault();
    const formData = { ...props.formObj };
    formData.current_step = 2;
    props.setFormObj(formData);
    navigate('/client-portal/sleeve/edit/' + formData.envelope_uuid + '/2');
  }

  function onSaveExit(e) {
    e.preventDefault();
    onSubmitForm(1);
  }

  function onSave(e) {
    e.preventDefault();
    onSubmitForm(2);
  }

  function onNext(e) {
    e.preventDefault();
    onSubmitForm(2);
  }



  const handleDownloadSampleCSV = () => {
    const csvContent = `type(1 = Short Text | 2 = Long Text | 3 = Dropdown | 4 = Single Choice | 5 = Multiple Choice | 6 = File Upload | 7 = Content Block | 8 = Date,name,sub_label,options
1,Client Name,Enter your full name,
2,Project Description,Provide a detailed description of your project,
3,Preferred Contact Method,Select your preferred contact method,Email|Phone|In-Person
4,Urgency Level,How urgent is your request?,Low|Medium|High
5,Required Documents,Select all documents you can provide,Passport|Driver's License|Utility Bill
6,Proof of Identity,Upload a valid ID document,
7,Instructions,Please complete all fields accurately to process your request,
8,Preferred Meeting Date,Select a date for your consultation,`;

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'sample_form_template.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleQuestionImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        let questions = [];
        const content = event.target.result;

        if (file.name.endsWith('.csv')) {
          const lines = content.split('\n');
          const headers = lines[0].split(',').map(h => h.trim());

          for (let i = 1; i < lines.length; i++) {
            if (!lines[i].trim()) continue;

            const values = lines[i].split(',');
            const question = {
              type: parseInt(values[0]) || 1,
              name: values[1] || '',
              sub_label: values[2] || '',
              options: [3, 4, 5].includes(parseInt(values[0]))
                ? (values[3] ? values[3].split('|').map(opt => ({ id: 0, name: opt.trim() })) : [])
                : [],
              is_show: false,
              id: 0
            };
            questions.push(question);
          }
        } else if (file.name.endsWith('.json')) {
          questions = JSON.parse(content);
        }

        const newForm = {
          id: 0,
          request_id: 0,
          form_name: `Imported Form ${props.formObj.fill_forms.length + 1}`,
          form_questions: questions
        };

        setRequestFormData(newForm);
        setSmartFormData(newForm);

        btnRequestForm.current?.click();

      } catch (error) {
        toast.error('Error parsing file: ' + error.message);
      }
    };

    if (file.name.endsWith('.csv')) {
      reader.readAsText(file);
    } else if (file.name.endsWith('.xlsx')) {
      reader.readAsText(file);
    } else if (file.name.endsWith('.json')) {
      reader.readAsText(file);
    } else {
      toast.error('Unsupported file format');
    }

    e.target.value = '';
  };
  function onSubmitForm(type) {

    const envelopeFormData = { ...props.formObj };
    //if (envelopeFormData.documents.length === 0 && envelopeFormData.sign_documents.length === 0) {
    if (envelopeFormData.documents.length === 0 && envelopeFormData.fill_forms.length === 0 && envelopeFormData.sign_documents.length === 0) {
      toast.error("Please create Document");
    } else {

      //Validation of check sign documents fillable or not.
      /*
      if (envelopeFormData.documents.length === 0){
          let checkAnyOneFillable = false;
          for (let i = 0; i < envelopeFormData.sign_documents.length; i++) {
              if(envelopeFormData.sign_documents[i].request_id !== ""){
                  checkAnyOneFillable = true;
                  break;
              }
          }
          if(checkAnyOneFillable === false){
              toast.error("Please make fillable sign request.");
              return false;
          }
      }
      */

      if (envelopeFormData.sign_documents.length !== 0) {
        let isAllFillable = true;
        for (let i = 0; i < envelopeFormData.sign_documents.length; i++) {
          if (envelopeFormData.sign_documents[i].request_id === null) {
            isAllFillable = false;
            break;
          }
        }
        if (isAllFillable === false) {
          toast.error("Please make fillable sign request.");
          return false;
        }
      }

      let obj = {
        id: envelopeFormData.envelope_id,
        document: envelopeFormData.documents,
        request_form: envelopeFormData.fill_forms,
        sign_document: envelopeFormData.sign_documents,
      };

      props.setLoading(true);
      modifyDocumentRequestFormOrders(obj)
        .then((response) => {
          if (type === 1) {
            navigate("/manage/draft");
          } else {
            envelopeFormData.current_step = 4;
            props.setFormObj(envelopeFormData);
            navigate('/client-portal/sleeve/edit/' + envelopeFormData.envelope_uuid + '/4');
          }
          toast.success(response.data.message);
          props.setLoading(false);
        })
        .catch((err) => {
          props.setLoading(false);
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }

  const onDocumentEdit = (e, data) => {
    e.preventDefault();
    props.setLoading(true);
    let obj = {
      id: data.id,
    };
    getEnvelopeDocumentDetail(obj)
      .then((response) => {
        let formData = { ...docData };
        formData.id = response.data.data.id;
        formData.request_id = response.data.data.request_id;
        formData.doc_name = response.data.data.doc_name;
        formData.doc_detail = response.data.data.doc_detail;
        let files = [];
        for (let i = 0; i < response.data.data.files.length; i++) {
          files.push({
            id: response.data.data.files[i]["id"],
            name: response.data.data.files[i]["file_name"],
            kb: response.data.data.files[i]["file_size"],
            path: response.data.data.files[i]["file_path"],
            file: "",
          });
        }
        formData.documents = files;
        formData.date_format = response.data.data.date_format;
        setDocData(formData);
        btnDocument.current?.click();
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };

  const onDocumentClone = (e, data) => {
    e.preventDefault();
    props.setLoading(true);
    let obj = {
      id: data.id,
    };
    getEnvelopeDocumentDetail(obj)
      .then((response) => {
        let formData = { ...docData };
        formData.id = 0;
        formData.request_id = response.data.data.request_id;
        formData.doc_name = response.data.data.doc_name;
        formData.doc_detail = response.data.data.doc_detail;
        formData.documents = [];
        formData.date_format = response.data.data.date_format;
        setDocData(formData);
        btnDocument.current?.click();
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };

  const onDocumentDelete = (e, data) => {
    e.preventDefault();

    props.setLoading(true);
    let obj = {
      id: data.id,
    };
    removeEnvelopeDocument(obj)
      .then((response) => {
        let envelopeData = { ...props.formObj };
        let index = envelopeData.documents.findIndex((x) => x.id === obj.id);
        envelopeData.documents.splice(index, 1);
        props.setFormObj(envelopeData);
        toast.success(response.data.message);
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };

  const onRequestFormEdit = (e, data) => {

    e.preventDefault();
    props.setLoading(true);
    let obj = {
      id: data.id,
    };
    getEnvelopeRequestInformationDetail(obj)
      .then((response) => {
        let formData = { ...requestFormData };
        let smartformData = { ...smartFormData };
        formData.id = response.data.data.id;
        formData.request_id = response.data.data.request_id;
        formData.form_name = response.data.data.form_name;
        formData.form_questions = response.data.data.questions;
        setRequestFormData(formData);
        setSmartFormData(smartformData);
        btnRequestForm.current?.click();
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };

  const onRequestClone = (e, data) => {

    e.preventDefault();
    props.setLoading(true);
    let obj = {
      id: data.id,
    };
    getEnvelopeRequestInformationDetail(obj)
      .then((response) => {
        let formData = { ...requestFormData };
        let smartformDatam = { ...smartFormData };
        formData.id = 0;
        formData.request_id = response.data.data.request_id;
        formData.form_name = response.data.data.form_name;
        let questionList = response.data.data.questions;
        for (let i = 0; i < questionList.length; i++) {
          questionList[i]['id'] = 0;
          for (let j = 0; j < questionList[i]['options'].length; j++) {
            questionList[i]['options'][j]['id'] = 0;
          }
        }
        formData.form_questions = questionList;
        setRequestFormData(formData);
        setSmartFormData(smartformDatam);
        btnRequestForm.current?.click();
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };

  const onRequestFormDelete = (e, data) => {
    e.preventDefault();

    props.setLoading(true);
    let obj = {
      id: data.id,
    };
    removeEnvelopeRequestForm(obj)
      .then((response) => {
        let envelopeData = { ...props.formObj };
        let index = envelopeData.fill_forms.findIndex((x) => x.id === obj.id);
        envelopeData.fill_forms.splice(index, 1);
        props.setFormObj(envelopeData);
        toast.success(response.data.message);
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };

  const handleUseDocFormTemplate = (e, type) => {
    e.preventDefault();
    setFromTemplate(type);
    setIsUseFromTemplate(true);

  };

  const handleDownload = async (e, obj) => {
    e.preventDefault();
    props.setLoading(true);
    await Utils.downloadAnyFile(obj.path, obj.file_name);
    props.setLoading(false);
  };

  const onRequestSignDocumentDelete = (e, data) => {
    e.preventDefault();

    props.setLoading(true);
    let obj = {
      id: data.id,
    };
    removeEnvelopeSignDocument(obj)
      .then((response) => {
        let envelopeData = { ...props.formObj };
        let index = envelopeData.sign_documents.findIndex((x) => x.id === obj.id);
        envelopeData.sign_documents.splice(index, 1);
        props.setFormObj(envelopeData);
        toast.success(response.data.message);
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };

  const onRequestSignDocumentRender = async (e, data) => {
    // console.log("Render make fillable form");
    e.preventDefault();

    // const keysToRemove = ["mousePosition", "pagesPosition", "placeholders"];
    // keysToRemove.forEach(key => localStorage.removeItem(key));

    props.setLoading(true);
    await setSignatureDocumentData(data);
    await setMakeFillable(true);
    btnSignDocumentPopup.current?.click();
  };



  const handleMakeFillable = () => {
    let current = (makeFillable === false) ? true : false;
    setMakeFillable(current);
  }

  useEffect(() => {
    const makeFillableAsync = async () => {
      if (directMakeFillableOpen === true) {
        const keysToRemove = ["mousePosition", "pagesPosition", "placeholders"];
        keysToRemove.forEach(key => localStorage.removeItem(key));
        await setMakeFillable(true);
        btnSignDocumentPopup.current?.click();
        setDirectMakeFillableOpen(false);
      }
    };

    makeFillableAsync(); // Call the async function
  }, [directMakeFillableOpen]);

  // Add request handler
  // const handleAddRequest = () => {
  //   if (!requestName) return;
  //   setRequests([
  //     ...requests,
  //     { name: requestName, type: requestType, desc: requestDesc }
  //   ]);
  //   setRequestName("");
  //   setRequestType("Document");
  //   setRequestDesc("");
  // };

  // Add Request button handlers for each section
  // const handleAddDocumentRequest = () => {
  //   btnDocument.current?.click();
  // };
  // const handleAddInformationRequest = () => {
  //   btnRequestForm.current?.click();
  // };
  // const handleAddSignatureRequest = () => {
  //   btnSignDocumentPopup.current?.click();
  // };

  // const initialForms = [
  //   { id: 1, name: "Imported Form 1" },
  //   { id: 2, name: "Imported Form 2" },
  //   { id: 3, name: "Imported Form 3" }
  // ];

  // const [forms, setForms] = useState(initialForms);

  // Drag and drop handlers
  // const handleDragStart = (index) => {
  //   formDragItem.current = index;
  // };
  // const handleDragEnter = (index) => {
  //   formDragOverItem.current = index;
  // };
  // const handleDragEnd = () => {
  //   const listCopy = [...forms];
  //   const dragged = listCopy.splice(formDragItem.current, 1)[0];
  //   listCopy.splice(formDragOverItem.current, 0, dragged);
  //   setForms(listCopy);
  //   formDragItem.current = null;
  //   formDragOverItem.current = null;
  // };

  const [isMyFilesEnabled, setIsMyFilesEnabled] = useState(true); // default true

  const handleAddRequestClick = async (e) => {
    try {
      const res = await checkMyFilesEnabled({});
      const enabled = res?.data?.data?.myfiles_enabled === true;
      setIsMyFilesEnabled(enabled);
    } catch (err) {
      setIsMyFilesEnabled(false);
    }
  };

  return (
    <div>
      <div className="sleeve-gradient-bg">
        <div className="sleeve-main-card" style={{ marginTop: 24 }}>
          <h2 className="sleeve-title mb-1 text-center">Request Documents</h2>
          <div className="sleeve-subtitle text-center mb-4">
            Choose from templates or create custom document requests
          </div>
          {/* Card Selector */}
          <div className="recipient-details-card-custom mb-4">
            <div className="doc-templates-header">
              <div className="sleeve-section-title">
                <i className="bi bi-download"></i>
                <span className="ms-2">Document Request Templates</span>
              </div>
              {selectedTab !== 'signature' && (
                <div className="doc-templates-header-btn-wrapper">
                  <button
                    type="button"
                    className="sleeve-add-btn"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#AddDocFormTemplate"
                    onClick={e => handleUseDocFormTemplate(e, 1)}
                  >
                    <span className="plus-icon">+</span> Add From Templates
                  </button>
                </div>
              )}
            </div>
            <div className="doc-templates-cards custom-doc-templates-cards">

              {/* Document Request Builde */}
              <div
                className={`doc-template-card${selectedTab === "DocumentRequest" ? " active" : ""}`}
                onClick={() => setSelectedTab("DocumentRequest")}
              >
                <div className="doc-template-icon">
                  <i className="bi bi-card-list"></i>
                </div>
                <div className="doc-template-title">Document Request Builder</div>
              </div>

              {/* Information Request */}
              <div
                className={`doc-template-card${selectedTab === "InformationRequest" ? " active" : ""}`}
                onClick={() => setSelectedTab("InformationRequest")}
              >
                <div className="doc-template-icon">
                  <i className="bi bi-file-earmark-text"></i>
                </div>
                <div className="doc-template-title">Information Request (Form Builder)</div>
              </div>

              {/* Signature Request */}
              <div
                className={`doc-template-card${selectedTab === "signature" ? " active" : ""}`}
                onClick={() => setSelectedTab("signature")}
              >
                <div className="doc-template-icon">
                  <i className="bi bi-pencil-square"></i>
                </div>
                <div className="doc-template-title">Signature Request</div>
              </div>

              {/* Smart Question */}
              {/* <div
                className={`doc-template-card${selectedTab === "SmartQuestion" ? " active" : ""}`}
                onClick={() => setSelectedTab("SmartQuestion")}
              >
                <div className="doc-template-icon">
                  <i className="bi bi-pencil-square"></i>
                </div>
                <div className="doc-template-title">Smart Question</div>
              </div> */}
            </div>
          </div>

          {/* Main content area: keep all logic/handlers/props as before, just wrap in a card */}
          <div className="sleeve-section-requests">
            <div className="col-lg-12">
              <div className="tab-content" id="nav-tabContent">
                <div className={`tab-pane fade${selectedTab === 'DocumentRequest' ? ' active show' : ''}`} id="MyTemplates-detail" role="tabpanel" aria-labelledby="MyTemplatesDetails">
                  <div className="sleeve-section-form">
                    <div className="doc-request-header">
                      <div>
                        <h2 className="sleeve-section-title">
                          <span>
                            <i className="bi bi-card-list me-2" aria-hidden="true"></i> Document Request Builder
                          </span>
                        </h2>
                      </div>
                      <div>
                        <button type="button" data-bs-toggle="offcanvas" data-bs-target="#Add-document"
                          ref={btnDocument} aria-controls="Add-document" data-toggle="tooltip"
                          title={Lang.env_add_document}
                          className="step2-add-btn ms-auto"
                          onClick={handleAddRequestClick}
                        >
                          <span className="me-3">+</span>Add Request
                        </button>
                      </div>
                    </div>
                    {/* List of requests (if any) */}
                    {selectedTab === 'DocumentRequest' && (
                      <div>
                        {props.formObj.documents.length === 0 ? (
                          <div className="step2-empty-state text-center py-5">
                            <i className="bi bi-file-earmark-text mb-3" style={{ fontSize: 48 }}></i>
                            <div className="fw-semibold" style={{ fontSize: 20 }}>No document requests configured yet</div>
                            <div style={{ fontSize: 15 }}>Select templates or add custom requests to get started</div>
                          </div>
                        ) : (
                          <div className="form-items-list mt-2">
                            {props.formObj.documents.map((item, index) => (
                              <div
                                key={index}
                                className={`form-item${docDragOverIndex === index ? ' drag-over' : ''}`}
                                draggable
                                onDragStart={() => handleDocDragStart(index)}
                                onDragEnter={() => handleDocDragEnter(index)}
                                onDragEnd={handleDocDragEnd}
                                onDragOver={e => e.preventDefault()}

                              >
                                <div className="form-item-left"
                                  style={{ cursor: "grab" }}
                                  onDragStart={(e) => formDragStart(e, index)}
                                  onDragEnter={(e) => formDragEnter(e, index)}
                                  onDragEnd={formDrop}
                                >
                                  <img src="/images/dots_rectangle.webp" alt="image4" className="me-3" />
                                  {item.name}
                                </div>
                                <div className="form-item-right">
                                  {/* <div className="recipient-badges">
                                    {parseInt(item.request_id) === 0 ? (
                                      <div className="recipient-badge-everyone">
                                        <i className="bi bi-people"></i>
                                        Everyone
                                      </div>
                                    ) : (
                                      <>
                                        {item.request_display.map((recipient, i) => (
                                          <div
                                            key={i}
                                            className="recipient-badge"
                                            data-toggle="tooltip"
                                            data-placement="right"
                                            title=""
                                            data-bs-original-title={recipient.full_name}
                                          >
                                            {recipient.display}
                                          </div>
                                        ))}
                                      </>
                                    )}
                                  </div> */}

                                  <div className="action-buttons">
                                    <button
                                      data-toggle="tooltip"
                                      title="Edit"
                                      onClick={e => {
                                        e.stopPropagation();
                                        onDocumentEdit(e, item);
                                      }}
                                      className="action-btn"
                                    >
                                      <i className="bi bi-pencil-fill" />
                                    </button>
                                    <button
                                      title="Clone"
                                      data-toggle="tooltip"
                                      onClick={e => onDocumentClone(e, item)}
                                      className="action-btn"
                                    >
                                      <i className="bi bi-copy" />
                                    </button>
                                    <button
                                      title="Delete"
                                      data-toggle="tooltip"
                                      onClick={e => onDocumentDelete(e, item)}
                                      className="action-btn-delete action-btn"
                                    >
                                      <i className="bi bi-trash" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </ div>
                    )}
                  </div>
                </div>
                {/* Information Request */}
                <div className={`tab-pane fade${selectedTab === 'InformationRequest' ? ' active show' : ''}`} id="sharedWithMe" role="tabpanel" aria-labelledby="sharedWithMe-tab">
                  <div className="sleeve-section-form">
                    <div className="doc-request-header doc-request-header-info">
                      <div>
                        <h2 className="sleeve-section-title">
                          <span>
                            <i className="bi bi-card-list me-2" aria-hidden="true"></i>Information Request (Form Builder)
                          </span>
                        </h2>
                      </div>
                      <div className="info-request-actions">
                        <button
                          type="button"
                          className="doc-request-action-btn me-2"
                          data-toggle="tooltip"
                          data-bs-original-title="Upload a CSV file to import questions into your form."
                          onClick={() => document.getElementById('importQuestions').click()}
                        >
                          <i className="bi bi-upload me-2"></i>Import
                        </button>
                        <button
                          type="button"
                          className="doc-request-action-btn me-2"
                          onClick={handleDownloadSampleCSV}
                          data-toggle="tooltip"
                          data-bs-original-title="Download a sample CSV to see the format for importing questions."
                        >
                          <i className="bi bi-download me-2"></i>Download
                        </button>
                        <button
                          type="button"
                          className="step2-add-btn ms-auto"
                          data-bs-toggle="offcanvas"
                          ref={btnRequestForm}
                          data-bs-target="#MakeForm"
                          data-toggle="tooltip"
                          title={Lang.env_add_question}
                        >
                          <span className="me-3">+</span>Create a Form
                        </button>
                        <input
                          type="file"
                          id="importQuestions"
                          style={{ display: 'none' }}
                          accept=".csv,.xlsx,.json"
                          onChange={handleQuestionImport}
                        />

                      </div>
                    </div>

                    {selectedTab === 'InformationRequest' && (
                      <div>
                        {props.formObj.fill_forms.length === 0 ? (
                          <div className="step2-empty-state text-center py-5">
                            <i className="bi bi-file-earmark-text mb-3" style={{ fontSize: 48 }}></i>
                            <div className="fw-semibold" style={{ fontSize: 20 }}>No Information Request configured yet</div>
                            <div style={{ fontSize: 15 }}>Select templates or add custom requests to get started</div>
                          </div>
                        ) : (
                          <div className="form-items-list mt-2">
                            {props.formObj.fill_forms.map((item, index) => (
                              <div
                                key={index}
                                className={`form-information-item form-item${formDragOverIndex === index ? ' drag-over' : ''}`}
                                draggable
                                onDragStart={() => formDragStart(null, index)}
                                onDragEnter={() => formDragEnter(null, index)}
                                onDragEnd={formDrop}
                                onDragOver={e => e.preventDefault()}
                              >
                                <div className="form-item-left">
                                  <div
                                    className="accordion_text"
                                    style={{ cursor: "grab" }}
                                    onClick={(e) => onRequestFormEdit(e, item)}
                                  >
                                    <img src="/images/dots_rectangle.webp" alt="image4" className="me-3" />
                                    {item.name}
                                  </div>
                                </div>
                                <div className="form-item-right">
                                  {/* <div className="recipient-badges">
                                    {parseInt(item.request_id) === 0 ? (
                                      <div className="recipient-badge-everyone">
                                        <i className="bi bi-people"></i>
                                        Everyone
                                      </div>
                                    ) : (
                                      <>
                                        {(item.request_display || []).map((recipient, i) => (
                                          <div
                                            key={i}
                                            className="recipient-badge"
                                            data-toggle="tooltip"
                                            data-placement="right"
                                            title={recipient.full_name}
                                          >
                                            {recipient.display}
                                          </div>
                                        ))}
                                      </>
                                    )}
                                  </div> */}
                                  <div className="action-buttons">
                                    <button
                                      onClick={(e) => onRequestFormEdit(e, item)}
                                      className="action-btn"
                                      data-toggle="tooltip"
                                      title="Edit"
                                    >
                                      <i className="bi bi-pencil-fill" />
                                    </button>
                                    <button
                                      onClick={(e) => onRequestClone(e, item)}
                                      className="action-btn"
                                      data-toggle="tooltip"
                                      title="Clone"
                                    >
                                      <i className="bi bi-copy" />
                                    </button>
                                    <button
                                      onClick={(e) => onRequestFormDelete(e, item)}
                                      className="action-btn-delete action-btn"
                                      data-toggle="tooltip"
                                      title="Delete"
                                    >
                                      <i className="bi bi-trash" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className={`tab-pane fade${selectedTab === 'signature' ? ' active show' : ''}`} id="DocutikTemplates" role="tabpanel" aria-labelledby="DocutikTemplates-tab">
                  <div className="sleeve-section-form">
                    <div className="doc-request-header">
                      <div>
                        <h2 className="sleeve-section-title">
                          <span>
                            <i className="bi bi-pencil-square me-2" aria-hidden="true"></i> Signature Request
                          </span>
                        </h2>
                      </div>
                      <div className="info-request-actions">
                        <button
                          type="button"
                          className="step2-add-btn ms-auto"
                          style={{ minWidth: 160 }}
                          data-bs-toggle="offcanvas"
                          data-bs-target="#pdfUploadForm"
                          data-toggle="tooltip"
                          data-bs-original-title="Request for digital signatures from designated recipients."
                          onClick={handleAddRequestClick}
                        >
                          <span className="me-2">+</span>Create a Form
                        </button>
                      </div>
                    </div>
                    {selectedTab === 'signature' && (
                      <div>
                        {props.formObj.sign_documents.length === 0 ? (
                          <div className="step2-empty-state text-center py-5">
                            <i className="bi bi-file-earmark-text mb-3" style={{ fontSize: 48 }}></i>
                            <div className="fw-semibold" style={{ fontSize: 20 }}>No signature requests configured yet</div>
                            <div style={{ fontSize: 15 }}>Add custom requests to get started</div>
                          </div>
                        ) : (
                          <>
                            <div className="form-items-list mt-2">
                              {props.formObj.sign_documents.map((item, index) => (
                                <div
                                  key={index}
                                  className={`form-signature-item form-item${signDragOverIndex === index ? ' drag-over' : ''}`}
                                  draggable
                                  onDragStart={() => signDragStart(null, index)}
                                  onDragEnter={() => signDragEnter(null, index)}
                                  onDragEnd={signDrop}
                                  onDragOver={e => e.preventDefault()}
                                >
                                  <div className="form-item-left">
                                    <div
                                      className="accordion_text"
                                      style={{ cursor: "grab" }}
                                      onClick={(e) => onRequestSignDocumentRender(e, item)}
                                    >
                                      <img src="/images/dots_rectangle.webp" alt="image4" className="me-3" />
                                      {item.name}
                                    </div>
                                  </div>
                                  <div className="form-item-right">
                                    <div className="recipient-badges">

                                      {parseInt(item.request_id) === 0 ? (
                                        <div className="recipient-badge-everyone">
                                          <i className="bi bi-people"></i>
                                          Everyone
                                        </div>
                                      ) : (
                                        <>
                                          {item.request_display.map((recipient, i) =>
                                            <div
                                              key={i}
                                              className="recipient-badge"
                                              data-toggle="tooltip"
                                              data-placement="right"
                                              title={recipient.full_name}
                                            // style={{ padding: '6px 11px' }}
                                            >
                                              {recipient.display}
                                            </div>
                                          )}
                                        </>
                                      )}

                                      {(item.request_display.length === 0 && item.request_id !== 0) ? (
                                        <span onClick={(e) => onRequestSignDocumentRender(e, item)} className="make_fillable_btn me-3 cur-pointer" >
                                          <i className="bi bi-pencil-square-o" data-toggle="tooltip" data-placement="right"
                                            title="" data-bs-original-title={(item.request_display.length === 0) ? 'Make fillable' : 'Edit Live Form'} aria-hidden="true" /> {(item.request_display.length === 0) ? 'Make fillable' : 'Edit Live Form'}
                                        </span>
                                      ) : (
                                        <span onClick={(e) => onRequestSignDocumentRender(e, item)} className="make_fillable_btn edit_live_form_btn me-3 cur-pointer" >
                                          <i className="bi bi-pencil-square-o" data-toggle="tooltip" data-placement="right"
                                            title="" data-bs-original-title={(item.request_display.length === 0 && item.request_id !== "0") ? 'Make fillable' : 'Edit Live Form'} aria-hidden="true" /> {(item.request_display.length === 0 && item.request_id !== "0") ? 'Make fillable' : 'Edit Live Form'}
                                        </span>
                                      )
                                      }
                                      <button
                                        onClick={(e) => handleDownload(e, item)}
                                        className="action-btn"
                                        data-toggle="tooltip"
                                        title="Download"
                                      >
                                        <i className="bi bi-download" />
                                      </button>

                                      <button
                                        onClick={(e) => onRequestSignDocumentDelete(e, item)}
                                        className="action-btn-delete action-btn"
                                        data-toggle="tooltip"
                                        title="Delete"
                                      >
                                        <i className="bi bi-trash" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                        <span className="d-none" ref={btnSignDocumentPopup} data-bs-toggle="offcanvas" data-bs-target="#makeFillableForm" ></span>
                      </div>
                    )}
                  </div>
                </div>

                {/* <DocFormSelectionPopup formObj={props.formObj} setFormObj={props.setFormObj} setLoading={props.setLoading}></DocFormSelectionPopup> */}

              </div>
            </div>
            <div className="sleeve-step-buttons">
              <div>
                <button className="sleeve-btn-back" onClick={onBack}>
                  Back
                </button>
              </div>
              <div className="sleeve-step-buttons-right">
                <button className="sleeve-btn-save" onClick={onSaveExit}>
                  Save & Exit
                </button>
                <button className="sleeve-btn-next" onClick={onNext}>
                  Next
                </button>
              </div>
            </div>
          </div>

          <EnvelopePreview senderList={props.senderList} formObj={props.formObj} />

          <EnvelopeDocument
            formObj={props.formObj}
            setFormObj={props.setFormObj}
            setLoading={props.setLoading}
            isMyFilesEnabled={isMyFilesEnabled}
            docData={docData}
          />

          <EnvelopeRequestForm formObj={props.formObj} setFormObj={props.setFormObj} setLoading={props.setLoading}
            requestFormData={requestFormData} setRequestFormData={setRequestFormData} />

          <SmartForm formObj={props.formObj} setFormObj={props.setFormObj} setLoading={props.setLoading}
            requestFormData={smartFormData} setRequestFormData={setSmartFormData} />

          {/* <SmartForm /> */}

          {/* <DocFormSelectionPopup formObj={props.formObj} setFormObj={props.setFormObj} setLoading={props.setLoading}></DocFormSelectionPopup> */}

          <PdfUploadPopup formObj={props.formObj} setFormObj={props.setFormObj} setLoading={props.setLoading} setDirectMakeFillableOpen={setDirectMakeFillableOpen} setSignatureDocumentData={setSignatureDocumentData} isMyFilesEnabled={isMyFilesEnabled}></PdfUploadPopup>

          <MakeFillablePopup formObj={props.formObj} signatureDocumentData={signatureDocumentData} setFormObj={props.setFormObj} setLoading={props.setLoading} makeFillable={makeFillable} handleMakeFillable={handleMakeFillable}></MakeFillablePopup>
        </div>
        <DocFormTemplate fromTemplate={fromTemplate} setFromTemplate={setFromTemplate}
          formObj={props.formObj} setFormObj={props.setFormObj}
          isUseFromTemplate={isUseFromTemplate} setIsUseFromTemplate={setIsUseFromTemplate} />
      </div>
    </div >
  );
}

export default EnvelopeStep3;

